// @copyright  2025 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/accounting/accrued-expenses',
        component: () =>
            import('@/pages/[organisation]/accounting/accrued-expenses.vue'),
        name: 'accounting.accrued-expenses.search-accrued-expenses',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.accrued-expense.view-accrued-expenses',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/accounting/accrued-expenses/new.vue'),
                name: 'accounting.accrued-expenses.create-accrued-expense',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.accrued-expense.create-accrued-expense',
                },
            },
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/accounting/accrued-expenses/[id].vue'),
                name: 'accounting.accrued-expenses.view-accrued-expense',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.accrued-expense.view-accrued-expenses',
                },
            },
            {
                path: ':id/edit',
                component: () =>
                    import('@/pages/[organisation]/accounting/accrued-expenses/[id]/edit.vue'),
                name: 'accounting.accrued-expenses.update-accrued-expense',
                meta: {
                    loginRequired: true,
                    permission: 'access.accounting.accrued-expense.update-accrued-expense',
                },
            },
        ],
    },
];
